// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Balance Transfer Modal - Enterprise Corporate Design
   Matching GameManagement Theme
   ============================================ */

/* CSS Variables - Matching GameManagement Theme */
:root {
  --balance-modal-bg: #f8f9fa;
  --balance-modal-text: #000000;
  --balance-modal-text-muted: #4a5568;
  --balance-modal-border: rgba(135, 206, 235, 0.3);
  --light-sky-blue: #87ceeb;
  --light-red: #ff6b6b;
  --white: #ffffff;
  --navy-blue: #001f3f;
  --transition: all 0.2s ease;
}

/* ============================================
   Modal
   ============================================ */
.BalanceTransferModal_modalOverlay__qfH0V {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

.BalanceTransferModal_modal__ntqTY {
  background: var(--white);
  border-radius: 0.5rem;
  width: 100%;
  max-width: 500px;
  max-height: calc(100vh - 2rem);
  max-height: calc(100dvh - 2rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.BalanceTransferModal_modalHeader__JZ08Y {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  color: var(--white);
  border-radius: 0.5rem 0.5rem 0 0;
  flex-shrink: 0;
}

.BalanceTransferModal_modalTitle__D48kg {
  font-size: 1.125rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 0;
}

.BalanceTransferModal_closeButton__4XV1o {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: none;
  color: var(--white);
  cursor: pointer;
  border-radius: 0.25rem;
  transition: var(--transition);
}

.BalanceTransferModal_closeButton__4XV1o:hover {
  background: rgba(255, 255, 255, 0.1);
}

.BalanceTransferModal_modalBody__PtG8n {
  padding: 1.5rem;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
}

.BalanceTransferModal_modalFooter__WMvk2 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.25rem 1.5rem;
  border-top: 1px solid var(--balance-modal-border);
  background: #f8f9fa;
  border-radius: 0 0 0.5rem 0.5rem;
  flex-shrink: 0;
}

/* ============================================
   Form Elements
   ============================================ */
.BalanceTransferModal_formGroup__73Nna {
  margin-bottom: 1.25rem;
}

.BalanceTransferModal_label__UG3lf {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--balance-modal-text);
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.BalanceTransferModal_required__yD3VA {
  color: var(--light-red);
}

.BalanceTransferModal_input__DVADk {
  width: 100%;
  padding: 0.625rem 0.875rem;
  font-size: 0.875rem;
  border: 1px solid var(--balance-modal-border);
  border-radius: 0.375rem;
  background: var(--white);
  color: var(--balance-modal-text);
  transition: var(--transition);
  box-sizing: border-box;
}

.BalanceTransferModal_input__DVADk:focus {
  outline: none;
  border-color: var(--light-sky-blue);
  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);
}

.BalanceTransferModal_input__DVADk:read-only {
  background: #f8f9fa;
  cursor: not-allowed;
}

.BalanceTransferModal_input__DVADk::placeholder {
  color: var(--balance-modal-text-muted);
}

.BalanceTransferModal_modeToggle__bi3IX {
  display: flex;
  width: 100%;
  border: 1px solid var(--balance-modal-border);
  border-radius: 0.375rem;
  overflow: hidden;
  background: #f8f9fa;
}

.BalanceTransferModal_modeButton__FaC8w {
  flex: 1 1;
  padding: 0.625rem 0.875rem;
  border: none;
  background: transparent;
  color: var(--balance-modal-text-muted);
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: var(--transition);
}

.BalanceTransferModal_modeButton__FaC8w:not(:last-child) {
  border-right: 1px solid var(--balance-modal-border);
}

.BalanceTransferModal_modeButton__FaC8w:hover:not(:disabled):not(.BalanceTransferModal_modeButtonActive__-dg8u):not(.BalanceTransferModal_modeButtonActiveDebit__XnDfD) {
  background: rgba(135, 206, 235, 0.12);
  color: var(--balance-modal-text);
}

.BalanceTransferModal_modeButtonActive__-dg8u {
  background: var(--light-sky-blue);
  color: var(--white);
}

.BalanceTransferModal_modeButtonActiveDebit__XnDfD {
  background: var(--light-red);
  color: var(--white);
}

.BalanceTransferModal_modeButton__FaC8w:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.BalanceTransferModal_modeHint__1GcCG {
  margin: 0.5rem 0 0;
  font-size: 0.75rem;
  color: var(--balance-modal-text-muted);
}

.BalanceTransferModal_errorMessage__Hgwls {
  padding: 0.75rem;
  background: rgba(255, 107, 107, 0.1);
  color: var(--light-red);
  border: 1px solid rgba(255, 107, 107, 0.3);
  border-radius: 0.375rem;
  font-size: 0.875rem;
  margin-top: 0.5rem;
}

.BalanceTransferModal_submitButton__KEJ\\+c {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.5rem;
  background: var(--light-sky-blue);
  color: var(--white);
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.BalanceTransferModal_submitButtonDebit__Sg7k\\+ {
  background: var(--light-red);
}

.BalanceTransferModal_submitButton__KEJ\\+c:hover:not(:disabled) {
  background: #6bb6d4;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(135, 206, 235, 0.3);
}

.BalanceTransferModal_submitButton__KEJ\\+c.BalanceTransferModal_submitButtonDebit__Sg7k\\+:hover:not(:disabled) {
  background: #e85a5a;
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
}

.BalanceTransferModal_submitButton__KEJ\\+c:active:not(:disabled) {
  transform: translateY(0);
}

.BalanceTransferModal_submitButton__KEJ\\+c:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.BalanceTransferModal_cancelButton__8m4-X {
  padding: 0.625rem 1.5rem;
  background: transparent;
  color: var(--balance-modal-text);
  border: 1px solid var(--balance-modal-border);
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.BalanceTransferModal_cancelButton__8m4-X:hover {
  background: rgba(135, 206, 235, 0.1);
  border-color: var(--light-sky-blue);
}

.BalanceTransferModal_spinner__xAoCh {
  animation: BalanceTransferModal_spin__VfAKY 1s linear infinite;
}

@keyframes BalanceTransferModal_spin__VfAKY {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* ============================================
   Responsive Design - Mobile
   ============================================ */
@media (max-width: 768px) {
  .BalanceTransferModal_modal__ntqTY {
    max-width: 100%;
    max-height: calc(100vh - 3rem);
    max-height: calc(100dvh - 3rem);
    margin: 0.5rem;
  }

  .BalanceTransferModal_modalHeader__JZ08Y {
    padding: 1rem;
  }

  .BalanceTransferModal_modalTitle__D48kg {
    font-size: 1rem;
  }

  .BalanceTransferModal_modalBody__PtG8n {
    padding: 1rem;
  }

  .BalanceTransferModal_modalFooter__WMvk2 {
    padding: 1rem;
    flex-direction: column;
  }

  .BalanceTransferModal_submitButton__KEJ\\+c,
  .BalanceTransferModal_cancelButton__8m4-X {
    width: 100%;
  }
}

/* ============================================
   Accessibility
   ============================================ */
@media (prefers-reduced-motion: reduce) {
  * {
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }
}

.BalanceTransferModal_closeButton__4XV1o:focus-visible,
.BalanceTransferModal_submitButton__KEJ\\+c:focus-visible,
.BalanceTransferModal_cancelButton__8m4-X:focus-visible,
.BalanceTransferModal_modeButton__FaC8w:focus-visible,
.BalanceTransferModal_input__DVADk:focus-visible {
  outline: 2px solid var(--light-sky-blue);
  outline-offset: 2px;
}

.BalanceTransferModal_modalBody__PtG8n::-webkit-scrollbar {
  width: 8px;
}

.BalanceTransferModal_modalBody__PtG8n::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.BalanceTransferModal_modalBody__PtG8n::-webkit-scrollbar-thumb {
  background: var(--light-sky-blue);
  border-radius: 4px;
}

.BalanceTransferModal_modalBody__PtG8n::-webkit-scrollbar-thumb:hover {
  background: #6bb6d4;
}

`, "",{"version":3,"sources":["webpack://./src/styles/BalanceTransferModal.module.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,kDAAkD;AAClD;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,mCAAmC;EACnC,gDAAgD;EAChD,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;;iDAEiD;AACjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,0EAA0E;EAC1E,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,iDAAiD;EACjD,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,6CAA6C;EAC7C,uBAAuB;EACvB,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,6CAA6C;EAC7C,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,YAAY;EACZ,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,uBAAuB;EACvB,0CAA0C;EAC1C,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,gCAAgC;EAChC,6CAA6C;EAC7C,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,8DAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,eAAe;IACf,8BAA8B;IAC9B,+BAA+B;IAC/B,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,sCAAsC;IACtC,qCAAqC;EACvC;AACF;;AAEA;;;;;EAKE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* ============================================\n   Balance Transfer Modal - Enterprise Corporate Design\n   Matching GameManagement Theme\n   ============================================ */\n\n/* CSS Variables - Matching GameManagement Theme */\n:root {\n  --balance-modal-bg: #f8f9fa;\n  --balance-modal-text: #000000;\n  --balance-modal-text-muted: #4a5568;\n  --balance-modal-border: rgba(135, 206, 235, 0.3);\n  --light-sky-blue: #87ceeb;\n  --light-red: #ff6b6b;\n  --white: #ffffff;\n  --navy-blue: #001f3f;\n  --transition: all 0.2s ease;\n}\n\n/* ============================================\n   Modal\n   ============================================ */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n}\n\n.modal {\n  background: var(--white);\n  border-radius: 0.5rem;\n  width: 100%;\n  max-width: 500px;\n  max-height: calc(100vh - 2rem);\n  max-height: calc(100dvh - 2rem);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  color: var(--white);\n  border-radius: 0.5rem 0.5rem 0 0;\n  flex-shrink: 0;\n}\n\n.modalTitle {\n  font-size: 1.125rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin: 0;\n}\n\n.closeButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  color: var(--white);\n  cursor: pointer;\n  border-radius: 0.25rem;\n  transition: var(--transition);\n}\n\n.closeButton:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.modalBody {\n  padding: 1.5rem;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  overscroll-behavior: contain;\n}\n\n.modalFooter {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1.25rem 1.5rem;\n  border-top: 1px solid var(--balance-modal-border);\n  background: #f8f9fa;\n  border-radius: 0 0 0.5rem 0.5rem;\n  flex-shrink: 0;\n}\n\n/* ============================================\n   Form Elements\n   ============================================ */\n.formGroup {\n  margin-bottom: 1.25rem;\n}\n\n.label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--balance-modal-text);\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.required {\n  color: var(--light-red);\n}\n\n.input {\n  width: 100%;\n  padding: 0.625rem 0.875rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--balance-modal-border);\n  border-radius: 0.375rem;\n  background: var(--white);\n  color: var(--balance-modal-text);\n  transition: var(--transition);\n  box-sizing: border-box;\n}\n\n.input:focus {\n  outline: none;\n  border-color: var(--light-sky-blue);\n  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);\n}\n\n.input:read-only {\n  background: #f8f9fa;\n  cursor: not-allowed;\n}\n\n.input::placeholder {\n  color: var(--balance-modal-text-muted);\n}\n\n.modeToggle {\n  display: flex;\n  width: 100%;\n  border: 1px solid var(--balance-modal-border);\n  border-radius: 0.375rem;\n  overflow: hidden;\n  background: #f8f9fa;\n}\n\n.modeButton {\n  flex: 1;\n  padding: 0.625rem 0.875rem;\n  border: none;\n  background: transparent;\n  color: var(--balance-modal-text-muted);\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.modeButton:not(:last-child) {\n  border-right: 1px solid var(--balance-modal-border);\n}\n\n.modeButton:hover:not(:disabled):not(.modeButtonActive):not(.modeButtonActiveDebit) {\n  background: rgba(135, 206, 235, 0.12);\n  color: var(--balance-modal-text);\n}\n\n.modeButtonActive {\n  background: var(--light-sky-blue);\n  color: var(--white);\n}\n\n.modeButtonActiveDebit {\n  background: var(--light-red);\n  color: var(--white);\n}\n\n.modeButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.modeHint {\n  margin: 0.5rem 0 0;\n  font-size: 0.75rem;\n  color: var(--balance-modal-text-muted);\n}\n\n.errorMessage {\n  padding: 0.75rem;\n  background: rgba(255, 107, 107, 0.1);\n  color: var(--light-red);\n  border: 1px solid rgba(255, 107, 107, 0.3);\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  margin-top: 0.5rem;\n}\n\n.submitButton {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.625rem 1.5rem;\n  background: var(--light-sky-blue);\n  color: var(--white);\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.submitButtonDebit {\n  background: var(--light-red);\n}\n\n.submitButton:hover:not(:disabled) {\n  background: #6bb6d4;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(135, 206, 235, 0.3);\n}\n\n.submitButton.submitButtonDebit:hover:not(:disabled) {\n  background: #e85a5a;\n  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);\n}\n\n.submitButton:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.submitButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.cancelButton {\n  padding: 0.625rem 1.5rem;\n  background: transparent;\n  color: var(--balance-modal-text);\n  border: 1px solid var(--balance-modal-border);\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.cancelButton:hover {\n  background: rgba(135, 206, 235, 0.1);\n  border-color: var(--light-sky-blue);\n}\n\n.spinner {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ============================================\n   Responsive Design - Mobile\n   ============================================ */\n@media (max-width: 768px) {\n  .modal {\n    max-width: 100%;\n    max-height: calc(100vh - 3rem);\n    max-height: calc(100dvh - 3rem);\n    margin: 0.5rem;\n  }\n\n  .modalHeader {\n    padding: 1rem;\n  }\n\n  .modalTitle {\n    font-size: 1rem;\n  }\n\n  .modalBody {\n    padding: 1rem;\n  }\n\n  .modalFooter {\n    padding: 1rem;\n    flex-direction: column;\n  }\n\n  .submitButton,\n  .cancelButton {\n    width: 100%;\n  }\n}\n\n/* ============================================\n   Accessibility\n   ============================================ */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    transition-duration: 0.01ms !important;\n    animation-duration: 0.01ms !important;\n  }\n}\n\n.closeButton:focus-visible,\n.submitButton:focus-visible,\n.cancelButton:focus-visible,\n.modeButton:focus-visible,\n.input:focus-visible {\n  outline: 2px solid var(--light-sky-blue);\n  outline-offset: 2px;\n}\n\n.modalBody::-webkit-scrollbar {\n  width: 8px;\n}\n\n.modalBody::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.modalBody::-webkit-scrollbar-thumb {\n  background: var(--light-sky-blue);\n  border-radius: 4px;\n}\n\n.modalBody::-webkit-scrollbar-thumb:hover {\n  background: #6bb6d4;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `BalanceTransferModal_modalOverlay__qfH0V`,
	"modal": `BalanceTransferModal_modal__ntqTY`,
	"modalHeader": `BalanceTransferModal_modalHeader__JZ08Y`,
	"modalTitle": `BalanceTransferModal_modalTitle__D48kg`,
	"closeButton": `BalanceTransferModal_closeButton__4XV1o`,
	"modalBody": `BalanceTransferModal_modalBody__PtG8n`,
	"modalFooter": `BalanceTransferModal_modalFooter__WMvk2`,
	"formGroup": `BalanceTransferModal_formGroup__73Nna`,
	"label": `BalanceTransferModal_label__UG3lf`,
	"required": `BalanceTransferModal_required__yD3VA`,
	"input": `BalanceTransferModal_input__DVADk`,
	"modeToggle": `BalanceTransferModal_modeToggle__bi3IX`,
	"modeButton": `BalanceTransferModal_modeButton__FaC8w`,
	"modeButtonActive": `BalanceTransferModal_modeButtonActive__-dg8u`,
	"modeButtonActiveDebit": `BalanceTransferModal_modeButtonActiveDebit__XnDfD`,
	"modeHint": `BalanceTransferModal_modeHint__1GcCG`,
	"errorMessage": `BalanceTransferModal_errorMessage__Hgwls`,
	"submitButton": `BalanceTransferModal_submitButton__KEJ+c`,
	"submitButtonDebit": `BalanceTransferModal_submitButtonDebit__Sg7k+`,
	"cancelButton": `BalanceTransferModal_cancelButton__8m4-X`,
	"spinner": `BalanceTransferModal_spinner__xAoCh`,
	"spin": `BalanceTransferModal_spin__VfAKY`
};
export default ___CSS_LOADER_EXPORT___;
